import React from 'react';

const containerPrimary = (props) => (
    <div className={`align-self-start mr-3 u-size24x24`}>
        {props.children}
    </div>
);

export default containerPrimary;


// WEBPACK FOOTER //
// ./src/components/Flight/UI/Mobile/Tuple/ContainerPrimary/ContainerPrimary.js